
import { baseRoutes } from "@/router";
import { defineComponent } from "vue";
export default defineComponent({
  name: "Home",
  setup() {
    const toiawaseRoute = baseRoutes.filter((item) => item.path === "/link")[0]
      .children; //ドキュメント、問い合わせ
    const linksRoutes = toiawaseRoute?.concat(
      baseRoutes.filter((item) => item.path === "/terms")
    ); //利用規約

    return {
      linksRoutes,
    };
  },
});
